var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-custom-component",
    class: {
      'has-clear': _vm.clearable
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), (_vm.inputValue) ? _c('i', {
    staticClass: "clear-icon el-icon-circle-close",
    on: {
      "click": function($event) {
        _vm.inputValue = ''
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d42f08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputCustom/src/main.vue
// module id = null
// module chunks = 